import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var addExternalTrainingRes;
export const addExternalTrainingTodo = createAsyncThunk('addExternalTraining', async (val) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    // console.log(val)

    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'learner/create_external_training',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "ext_training_title": val.ext_training,
                "training_program_detail": val.program_details,
                "training_agency": val.training_agency,
                "training_date": val.training_date,
                "training_duration": val.duration,
                "training_proof": val.ceritificate,
                "other_documents": val.other,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return addExternalTrainingRes = res.data
    } catch (error) {
        return addExternalTrainingRes = error.response.data
    }
})